import { Organization } from './organization';
import { ObjectActionSet } from './permission';
import { Project, ProjectActivationState, ProjectState } from './project';

export class ProjectListItem extends Project {
    // organization attributes
    organizationName: string;
    organizationHandle: string;
    organizationDescription: string;
    role: { handle: string, name: string, objectActionList: Array<ObjectActionSet> };
    data: Project;
    hasOrgSettingsPermissions: boolean;
    hasPrjSettingsPermissions: boolean;
    hasSysSettingsPermissions: boolean;
    hasProjectCreatePermissions: boolean;
    hasProjectDeletePermissions: boolean;
    isSystemSettingsHidden: boolean;

    // display attributes
    projectStateDisplay: string;
    parsingVersion: string;

    // grid attributes
    isParent: boolean;
    isChild: boolean;
    isExpanded = false;
    parent: ProjectListItem;
    children = new Array<ProjectListItem>();

    static fromOrganization(value: Partial<Organization>): ProjectListItem {
        if (value) {
            const organizationItem = new ProjectListItem();
            Object.assign(organizationItem, value);
            organizationItem.isParent = true;
            return organizationItem;
        }
        return null;
    }

    static fromProject(value: Partial<Project>, parent?: ProjectListItem): ProjectListItem {
        if (value) {
            const project = new Project(value);
            const projectItem = new ProjectListItem();
            Object.assign(projectItem, project);
            projectItem.isChild = true;
            projectItem.data = project;
            projectItem.projectStateDisplay = projectItem.projectActivationState && projectItem.projectActivationState !== ProjectActivationState.ACTIVE
                ? projectItem.projectActivationState : projectItem.projectState;
            projectItem.parsingVersion = projectItem.data?.attributes?.find(a => a.name === 'parsingVersion')?.value;
            if (parent) {
                projectItem.parent = parent;
                parent.children.push(projectItem);
            }
            return projectItem;
        }
        return null;
    }

    isDisabled(option?: string): boolean {
        if (!this.isChild) {
            return false;
        }
        switch (option) {
            case 'Export ...':
            case 'Settings ...':
            case 'Edit ...': {
                if ((this.projectActivationState === ProjectActivationState.ACTIVE || this.projectActivationState === ProjectActivationState.DEACTIVATED) &&
                    this.projectState !== ProjectState.FAILURE) {
                    return false;
                }
                break;
            }
            case 'Delete': {
                if (this.projectState === ProjectState.AVAILABLE || this.projectActivationState === ProjectActivationState.DEACTIVATED ||
                    this.projectState === ProjectState.WARNING ||
                    this.projectActivationState === ProjectActivationState.DISABLED ||
                    this.projectActivationState === ProjectActivationState.IMPORT_FAILED) {
                    return false;
                }
                break;
            }
            default: {
                // no option => check disabled for grid row select disable
                if (this.projectActivationState === ProjectActivationState.DEACTIVATED && this.projectState === ProjectState.UNKNOWN) {
                    return false;
                }
                if ((this.projectActivationState === ProjectActivationState.ACTIVE || this.projectActivationState === ProjectActivationState.DEACTIVATED) &&
                    this.projectState !== ProjectState.FAILURE && this.projectState !== ProjectState.UNKNOWN) {
                    return false;
                }
                break;
            }
        }
        return true;
    }
}
